import paymentGatewayServices from '@/api/financial/paymentGatewayServices'

export default {
  namespaced: true,
  state: {
    gateways: [],
    gateway: {
      descricao: '',
      provedor: 'PAGBANK',
      ambiente: 'SANDBOX',
      clientId: '',
      clientSecret: '',
      webhookSecret: '',
      webhookUrl: '',
      tokenAtual: '',
      ativo: true,
      certificadoA1: null
    }
  },
  getters: {},
  mutations: {
    SET_GATEWAYS(state, data) {
      state.gateways = data
    },
    SET_GATEWAY(state, data) {
      state.gateway = data
    },
    RESET_GATEWAY(state) {
      state.gateway = {
        descricao: '',
        provedor: 'PAGBANK',
        ambiente: 'SANDBOX',
        clientId: '',
        clientSecret: '',
        webhookSecret: '',
        webhookUrl: '',
        tokenAtual: '',
        ativo: true,
        certificadoA1: null
      }
    }
  },
  actions: {
    loadAll({ commit }) {
      return paymentGatewayServices.loadAll().then(response => {
        commit('SET_GATEWAYS', response.data)
        return response
      })
    },
    loadById({ commit }, id) {
      return paymentGatewayServices.loadById(id).then(response => {
        commit('SET_GATEWAY', response.data)
        return response
      })
    },
    insert({ dispatch }, data) {
      return paymentGatewayServices.insert(data).then(response => {
        dispatch('loadAll')
        return response
      })
    },
    update({ dispatch }, { id, data }) {
      return paymentGatewayServices.update(id, data).then(response => {
        dispatch('loadAll')
        return response
      })
    },
    delete({ dispatch }, id) {
      return paymentGatewayServices.delete(id).then(response => {
        dispatch('loadAll')
        return response
      })
    },
    reset({ commit }) {
      commit('RESET_GATEWAY')
    }
  }
}
